import { withReducers } from 'Util/DynamicReducer';
import { connect } from 'react-redux';
import React from 'react';

import {
    SearchOverlayContainer as SourceSearchOverlayContainer,
    mapStateToProps,
    mapDispatchToProps,
} from 'SourceComponent/SearchOverlay/SearchOverlay.container';
import SearchBarReducer from 'Src/store/SearchBar/SearchBar.reducer';

export {
    mapStateToProps,
    mapDispatchToProps,
};

export class SearchOverlayContainer extends SourceSearchOverlayContainer {
    static propTypes = {
        closeSearch: this.propTypes
    }

    containerProps() {
        const {
            clearSearchResults,
            isHideOverlay,
            isLoading,
            searchCriteria,
            searchResults,
            closeSearch
        } = this.props;

        return {
            clearSearchResults,
            isHideOverlay,
            isLoading,
            searchCriteria,
            searchResults,
            closeSearch
        };
    }
}

export default withReducers({
    SearchBarReducer,
})(connect(
    mapStateToProps,
    mapDispatchToProps,
)(SearchOverlayContainer));
